import api from './api';

export const danhMucService = {

  getTonGiao: () => api.get('/danh-muc/ton-giao'),


  getTinhTrangHonNhan: () => api.get('/danh-muc/tinh-trang-hon-nhan'),


  getTrangThaiTuyenDung: () => api.get('/danh-muc/trang-thai-tuyen-dung'),


  getTrinhDo: () => api.get('/danh-muc/trinh-do'),


  getHinhThucDaoTao: () => api.get('/danh-muc/hinh-thuc-dao-tao'),


  getXepLoaiDaoTao: () => api.get('/danh-muc/xep-loai-dao-tao'),


  getTieuChiPV: () => api.get('/danh-muc/tieu-chi-pv'),


  getKetQuaPV: () => api.get('/danh-muc/ket-qua-pv'),
};

export default danhMucService;
